<template>
  <div class="main">

    <el-tabs v-model="activeName" type="border-card" style="width: 100%;">
      <el-tab-pane label="设备列表" name="first">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div>
              <el-input v-model="queryData.deviceName"  placeholder="请输入设备名称"></el-input>
              <el-input v-model="queryData.deviceSn"  placeholder="请输入设备唯一编号"></el-input>
              <el-select v-model="queryData.deviceStatus" placeholder="设备状态">
                <el-option label="请选择设备状态" value="0"></el-option>
                <el-option label="正常" value="1"></el-option>
                <el-option label="锁机" value="2"></el-option>
              </el-select>
              <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="起始时间" class="mr15"></el-date-picker>
              <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
              <el-button type="primary" @click="clickdialogAdd">新增</el-button>
              <UploadExcel @change="changeUploadExcel"></UploadExcel>
            </div>
          </div>
          <!-- search End -->

          <!-- 列表 -->
          <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
            <el-table-column prop="id" label="序号" min-width="60" sortable="custom"></el-table-column>
            <el-table-column prop="deviceName" label="设备名称" min-width="160" sortable="custom"></el-table-column>
            <el-table-column prop="deviceSn" label="识别码" min-width="160" sortable="custom"></el-table-column>
            <el-table-column prop="isOnline" label="设备状态" min-width="80">
              <template slot-scope="props">
                <el-tag :type="props.row.isOnline == 1 ? 'success' : 'info'" size="small">{{ props.row.isOnline == 1 ? '在线' : '离线' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="appVersion" label="软件版本" min-width="90" sortable="custom"></el-table-column>
            <el-table-column prop="firmWare" label="固件版本" min-width="90" sortable="custom"></el-table-column>
            <el-table-column label="位置" min-width="120">
              <template slot-scope="scope">
                {{ (scope.row.country || '') + (scope.row.province || '') + (scope.row.city || '') + (scope.row.district || '') || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="lastOnlineTime" label="最后上线时间" min-width="160"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="160" sortable="custom"></el-table-column>
            <el-table-column prop="Operation" label="操作" min-width="100">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-link :underline="false" type="danger" icon="el-icon-delete" class="mr12" @click="ClickDelete(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="查看日志" placement="top" :enterable="false">
                  <el-link :underline="false" type="warning" icon="el-icon-document" class="mr12" @click="clickViewLog(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="scope.row.deviceStatus == 2 ? '解锁' : '锁机'" placement="top" :enterable="false">
                  <el-link :underline="false" :type="scope.row.deviceStatus == 2 ? 'success' : 'danger'" :icon="scope.row.deviceStatus == 2 ? 'el-icon-unlock' : 'el-icon-lock'" class="mr12" @click="clickLockDevice(scope.row)"></el-link>
                </el-tooltip>
<!--                <el-tooltip class="item" effect="dark" content="绑定蓝牙设备" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-attract" class="mr12" @click="gotoDeviceBindblesn(scope.row)"></el-link>
                </el-tooltip> -->
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->

        <!---------------------- 以下是弹框内容 ---------------------->
        <!-- 新增 -->
        <el-dialog title="添加" :visible.sync="dialogAdd" width="26%" class="newAdd">
          <div class="addUser_body">
            <el-form ref="userMsg" :model="addData" label-width="120px">
              <el-form-item label="设备名称" :required=true>
                <el-input v-model="addData.deviceName" placeholder="请输入设备名称"></el-input>
              </el-form-item>
              <el-form-item label="设备唯一编号" :required=true>
                <el-input v-model="addData.deviceSn" placeholder="请输入设备唯一编号"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="DeviceInsert()" >确 认</el-button>
            <el-button @click="dialogAdd = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 新增 End -->

        <!-- 编辑信息 -->
        <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="26%" class="newAdd">
          <div class="addUser_body">
            <el-form ref="editForm" :model="editData" :rules="editRules" label-width="120px">
              <el-form-item label="设备名称" prop="deviceName">
                <el-input v-model="editData.deviceName" placeholder="请输入设备名称"></el-input>
              </el-form-item>
              <el-form-item label="设备唯一编号" prop="deviceSn">
                <el-input v-model="editData.deviceSn" placeholder="请输入设备唯一编号"></el-input>
              </el-form-item>
              <el-form-item label="设备状态" prop="deviceStatus">
                <el-select v-model="editData.deviceStatus" placeholder="设备状态">
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="锁机" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="软件版本">
                <el-input v-model="editData.appVersion" placeholder="软件版本" disabled></el-input>
              </el-form-item>
              <el-form-item label="固件版本号">
                <el-input v-model="editData.firmWare" placeholder="固件版本号" disabled></el-input>
              </el-form-item>
              <el-form-item label="位置">
                <el-input :value="(editData.country || '') + (editData.province || '') + (editData.city || '') + (editData.district || '')" placeholder="位置" disabled></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="DeviceUpdate()" >确 认</el-button>
            <el-button @click="dialogEdit = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑信息 End -->

        <!-- 删除 -->
        <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel">
          <div class="confirmMsg">确定删除？</div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="DeviceDelete" >确 定</el-button>
            <el-button @click="dialogDel = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 删除 End -->

        <!-- 设备日志 -->
        <el-dialog :title="'设备日志 - ' + logDeviceSn" :visible.sync="dialogLog" width="70%" class="logDialog" @close="closeLogDialog" :close-on-click-modal="false">
          <div class="log-container">
            <!-- 区块1: 过滤条件 -->
            <div class="log-filters">
              <span style="margin-right: 15px; color: #606266; font-size: 14px;">日志级别：</span>
              <el-checkbox-group v-model="logFilter.levels" size="small">
                <el-checkbox label="d">Debug</el-checkbox>
                <el-checkbox label="i">Info</el-checkbox>
                <el-checkbox label="w">Warn</el-checkbox>
                <el-checkbox label="e">Error</el-checkbox>
              </el-checkbox-group>
              <span style="margin-left: 30px; margin-right: 15px; color: #606266; font-size: 14px;">日志类型：</span>
              <el-checkbox-group v-model="logFilter.types" size="small">
                <el-checkbox label="app">应用</el-checkbox>
                <el-checkbox label="serial">串口</el-checkbox>
              </el-checkbox-group>
            </div>
            <!-- 区块2: 操作区 -->
            <div class="log-actions">
              <div class="log-actions-left">
                <span class="action-label">订阅时长：</span>
                <el-input-number v-model="logFilter.duration" :min="60" :max="1800" :step="60" size="small" style="width: 140px;"></el-input-number>
                <span class="action-unit">秒</span>
                <el-button type="primary" size="small" @click="logSubscribe" :loading="logSubscribing">
                  {{ logSubscribed ? '重新订阅' : '开始订阅' }}
                </el-button>
                <el-button type="warning" size="small" @click="logUnsubscribe" :disabled="!logSubscribed">取消订阅</el-button>
                <el-tag :type="logSubscribed ? 'success' : 'info'" size="small" style="margin-left: 10px;">
                  {{ logSubscribed ? '订阅中 (' + formatCountdown(logCountdown) + ')' : '未订阅' }}
                </el-tag>
              </div>
              <div class="log-actions-divider"></div>
              <div class="log-actions-right">
                <span class="action-label">拉取条数：</span>
                <el-input-number v-model="logFilter.limit" :min="10" :max="500" :step="10" size="small" style="width: 120px;"></el-input-number>
                <span class="action-unit">条</span>
                <el-button size="small" @click="logFetch" :loading="logFetching" plain>拉取历史</el-button>
                <el-button size="small" @click="logClear" plain>清空</el-button>
              </div>
            </div>
            <!-- 区块3: 日志显示区 -->
            <div class="log-display" ref="logDisplay">
              <div v-if="logEntries.length === 0" class="log-empty">暂无日志数据</div>
              <div v-for="(entry, index) in logEntries" :key="index" class="log-entry" :class="'log-level-' + entry.level">
                <span class="log-time">{{ formatLogTime(entry.ts) }}</span>
                <span class="log-level-tag" :class="'tag-' + entry.level">{{ levelLabel(entry.level) }}</span>
                <span class="log-type-tag">{{ entry.type }}</span>
                <span class="log-tag">[ {{ entry.tag }} ]</span>
                <span class="log-msg">{{ entry.msg }}</span>
              </div>
            </div>
          </div>
        </el-dialog>
        <!-- 设备日志 End -->
      </el-tab-pane>

      <!-- 绑定蓝牙设备 start -->
<!--      <el-tab-pane label="绑定蓝牙设备" name="second" disabled="disabled">
        <DeviceBindblesn ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></DeviceBindblesn>
      </el-tab-pane> -->
      <!-- 绑定蓝牙设备 end -->

    </el-tabs>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import DeviceBindblesn from '@/componentsSubVue/DeviceBindblesn.vue'
import UploadExcel from '../components/UploadExcel.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    DeviceBindblesn,
    UploadExcel
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        deviceName: '',
        deviceSn: '',
        deviceStatus: '0',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      // 新增
      dialogAdd: false,
      addData: {
        deviceName: '0',
        deviceSn: ''
      },
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        deviceName: '',
        deviceSn: '',
        deviceStatus: '',
        appVersion: '',
        country: '',
        deviceType: '',
        firmWare: '',
        province: '',
        city: '',
        district: ''
      },
      // 删除
      deleteForm: {
        id: ''
      },
      dialogDel: false,
      editRules: {
        deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        deviceSn: [{ required: true, message: '请输入设备唯一编号', trigger: 'blur' }],
        deviceStatus: [{ required: true, message: '请选择设备状态', trigger: 'change' }]
      },
      // 锁机
      lockLoading: false,
      // 设备日志
      dialogLog: false,
      logDeviceSn: '',
      logEntries: [],
      logSubscribing: false,
      logSubscribed: false,
      logFetching: false,
      logFetchTimer: null,
      logEventSource: null,
      logFilter: {
        levels: ['w', 'e'],
        types: ['app', 'serial'],
        duration: 300,
        limit: 100
      },
      logCountdown: 0,
      logCountdownTimer: null
    }
  },
  mounted () {
    this.DeviceList()
    this.DeviceNum()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    gotoDeviceBindblesn(row){
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    handleSizeChange (val) {
      this.page_size = val
      this.DeviceList()
      this.DeviceNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.DeviceList()
      this.DeviceNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.DeviceList()
      this.DeviceNum()
    },
    clickQuery () {
      this.page_no = 1
      this.DeviceList()
      this.DeviceNum()
    },
    clickQueryReset () {
      this.queryData.deviceName = ''
      this.queryData.deviceSn = ''
      this.queryData.deviceStatus = '0'
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.deviceName = ''
      this.addData.deviceSn = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.deviceName = row.deviceName
      this.editData.deviceSn = row.deviceSn
      this.editData.deviceStatus = row.deviceStatus.toString()
      this.editData.country = row.country
      this.editData.appVersion = row.appVersion
      this.editData.deviceType = row.deviceType
      this.editData.firmWare = row.firmWare
      this.editData.province = row.province
      this.editData.city = row.city
      this.editData.district = row.district
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },
    ClickDelete (row) {
      this.dialogDel = true
      this.deleteForm.id = row.id
    },
    changeUploadExcel (response) {
      console.log(response)
      Vue.prototype.FunRemindOnlyError(response)
      if (response.code === 1) {
        Vue.prototype.FunRemindAllways(response.data)
        this.DeviceList()
        this.DeviceNum()
      }
    },
    DeviceList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceName = that.queryData.deviceName
      data.deviceSn = that.queryData.deviceSn
      data.deviceStatus = that.queryData.deviceStatus
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DeviceNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceName = that.queryData.deviceName
      data.deviceSn = that.queryData.deviceSn
      data.deviceStatus = that.queryData.deviceStatus
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DeviceInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceName = that.addData.deviceName
      data.deviceSn = that.addData.deviceSn
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.DeviceList()
            that.DeviceNum()
            that.dialogAdd = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAdd = false
        })
    },
    DeviceUpdate: function () {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return
        var that = this
        var data = Vue.prototype.FunGetBaseSignData()
        data.id = that.editData.id
        data.deviceName = that.editData.deviceName
        data.deviceSn = that.editData.deviceSn
        data.deviceStatus = that.editData.deviceStatus
        data.deviceType = that.editData.deviceType
        // 以下字段可能为null，只在有实际值时才加入参数
        if (that.editData.country) data.country = that.editData.country
        if (that.editData.appVersion) data.appVersion = that.editData.appVersion
        if (that.editData.firmWare) data.firmWare = that.editData.firmWare
        if (that.editData.province) data.province = that.editData.province
        if (that.editData.city) data.city = that.editData.city
        if (that.editData.district) data.district = that.editData.district
        data.sign = Vue.prototype.FunGetSign(data)
        axios.post(Vue.prototype.global.Url_DeviceUpdate, Qs.stringify(data))
          .then(function (response) {
            that.dialogEdit = false
            Vue.prototype.FunRemindOnlyError(response.data)
            if (response.data.code === 1) {
              that.DeviceList()
              that.DeviceNum()
            }
          })
          .catch(function (error) {
            console.log(error)
            that.dialogEdit = false
          })
      })
    },
    DeviceDelete: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteForm.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.DeviceList()
            that.DeviceNum()
          }
          that.dialogDel = false
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDel = false
        })
    },
    // 锁机/解锁
    clickLockDevice (row) {
      var action = row.deviceStatus == 2 ? 'unlock' : 'lock'
      var actionText = action === 'lock' ? '锁定' : '解锁'
      var that = this
      this.$confirm('确定要' + actionText + '该设备？', '操作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = Vue.prototype.FunGetBaseSignData()
        data.deviceSn = row.deviceSn
        data.action = action
        data.sign = Vue.prototype.FunGetSign(data)
        axios.post(Vue.prototype.global.Url_DeviceLock, Qs.stringify(data))
          .then(function (response) {
            Vue.prototype.FunRemindOnlyError(response.data)
            if (response.data.code === 1) {
              that.$message.success(actionText + '指令已发送')
              that.DeviceList()
              that.DeviceNum()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }).catch(function () {})
    },
    // 打开日志对话框
    clickViewLog (row) {
      this.logDeviceSn = row.deviceSn
      this.logEntries = []
      this.logSubscribed = false
      this.dialogLog = true
      this.connectLogStream()
    },
    // 连接 SSE 日志流
    connectLogStream () {
      if (this.logEventSource) {
        this.logEventSource.close()
      }
      var url = Vue.prototype.global.Url_DeviceLogStream + this.logDeviceSn
      this.logEventSource = new EventSource(url)

      this.logEventSource.addEventListener('log_data', (event) => {
        var logs = JSON.parse(event.data)
        this.logEntries = this.logEntries.concat(logs)
        // 限制显示条数防止内存溢出
        if (this.logEntries.length > 2000) {
          this.logEntries = this.logEntries.slice(-1500)
        }
        this.$nextTick(() => {
          this.scrollLogToBottom()
        })
      })

      this.logEventSource.addEventListener('subscribe_ack', (event) => {
        var ack = JSON.parse(event.data)
        if (ack.success) {
          this.logSubscribed = true
          this.logSubscribing = false
          this.startLogCountdown(ack.expiresIn)
          this.$message.success('订阅成功，时长 ' + ack.expiresIn + ' 秒')
        } else {
          this.logSubscribing = false
          this.$message.error('订阅失败')
        }
      })

      this.logEventSource.addEventListener('fetch_result', (event) => {
        var result = JSON.parse(event.data)
        // 清除超时计时器
        if (this.logFetchTimer) {
          clearTimeout(this.logFetchTimer)
          this.logFetchTimer = null
        }
        // 历史日志插入到列表开头（因为是从新到旧排列，需要反转）
        var reversedLogs = result.logs ? result.logs.reverse() : []
        this.logEntries = reversedLogs.concat(this.logEntries)
        this.logFetching = false
        this.$message.success('拉取到 ' + reversedLogs.length + ' 条历史日志（缓冲区总计 ' + result.total + ' 条）')
      })

      this.logEventSource.addEventListener('lock_ack', (event) => {
        var ack = JSON.parse(event.data)
        if (ack.success) {
          this.$message.success('设备 ' + ack.deviceSn + ' 操作已确认')
        } else {
          this.$message.error('设备 ' + ack.deviceSn + ' 操作执行失败')
        }
        this.DeviceList()
        this.DeviceNum()
      })

      this.logEventSource.onerror = () => {
        console.log('SSE 连接错误')
      }
    },
    // 订阅日志
    logSubscribe () {
      this.logSubscribing = true
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.logDeviceSn
      data.levels = that.logFilter.levels.join(',')
      data.types = that.logFilter.types.join(',')
      data.duration = that.logFilter.duration
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceLogSubscribe, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code !== 1) {
            that.logSubscribing = false
            Vue.prototype.FunRemindOnlyError(response.data)
          }
          // 成功时由 SSE subscribe_ack 事件处理
        })
        .catch(function (error) {
          console.log(error)
          that.logSubscribing = false
        })
    },
    // 取消订阅
    logUnsubscribe () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.logDeviceSn
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceLogUnsubscribe, Qs.stringify(data))
        .then(function (response) {
          that.logSubscribed = false
          that.stopLogCountdown()
          Vue.prototype.FunRemindOnlyError(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 拉取历史日志
    logFetch () {
      this.logFetching = true
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.logDeviceSn
      data.levels = that.logFilter.levels.join(',')
      data.types = that.logFilter.types.join(',')
      data.limit = that.logFilter.limit
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceLogFetch, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.$message.info('日志拉取指令已发送，等待设备响应...')
            // logFetching 保持 true，等 SSE fetch_result 事件来重置
            that.logFetchTimer = setTimeout(function () {
              if (that.logFetching) {
                that.logFetching = false
                that.$message.warning('日志拉取超时，设备未响应')
              }
            }, 120000)
          } else {
            that.$message.error(response.data.msg || '发送日志拉取指令失败')
            that.logFetching = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.$message.error('请求失败')
          that.logFetching = false
        })
    },
    // 清空日志
    logClear () {
      this.logEntries = []
    },
    // 关闭日志对话框
    closeLogDialog () {
      if (this.logSubscribed) {
        this.logUnsubscribe()
      }
      if (this.logEventSource) {
        this.logEventSource.close()
        this.logEventSource = null
      }
      this.logEntries = []
      this.logSubscribed = false
      this.logSubscribing = false
      this.stopLogCountdown()
    },
    // 启动订阅倒计时
    startLogCountdown (seconds) {
      this.stopLogCountdown()
      this.logCountdown = seconds
      this.logCountdownTimer = setInterval(() => {
        this.logCountdown--
        if (this.logCountdown <= 0) {
          this.stopLogCountdown()
          this.logSubscribed = false
          this.$notify({
            title: '订阅已到期',
            message: '日志订阅时间已到，如需继续查看请重新订阅',
            type: 'warning',
            duration: 5000
          })
        }
      }, 1000)
    },
    // 停止订阅倒计时
    stopLogCountdown () {
      if (this.logCountdownTimer) {
        clearInterval(this.logCountdownTimer)
        this.logCountdownTimer = null
      }
      this.logCountdown = 0
    },
    // 格式化倒计时显示
    formatCountdown (seconds) {
      var m = Math.floor(seconds / 60)
      var s = seconds % 60
      return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0')
    },
    // 格式化日志时间戳
    formatLogTime (ts) {
      if (!ts) return ''
      var date = new Date(ts)
      var h = String(date.getHours()).padStart(2, '0')
      var m = String(date.getMinutes()).padStart(2, '0')
      var s = String(date.getSeconds()).padStart(2, '0')
      var ms = String(date.getMilliseconds()).padStart(3, '0')
      return h + ':' + m + ':' + s + '.' + ms
    },
    // 日志级别标签
    levelLabel (level) {
      var map = { d: 'DBG', i: 'INF', w: 'WRN', e: 'ERR' }
      return map[level] || level
    },
    // 滚动日志到底部
    scrollLogToBottom () {
      var el = this.$refs.logDisplay
      if (el) {
        el.scrollTop = el.scrollHeight
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 150px;
    margin-right: 15px;
  }

  .el-select{
    width: 150px;
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}

// 设备日志样式
.log-container {
  display: flex;
  flex-direction: column;
  height: 560px;
}

.log-filters {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.log-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;

  .log-actions-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .log-actions-divider {
    width: 1px;
    height: 28px;
    background: #dcdfe6;
    margin: 0 16px;
  }

  .log-actions-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .action-label {
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
  }

  .action-unit {
    font-size: 13px;
    color: #606266;
    margin-right: 4px;
  }
}

.log-display {
  flex: 1;
  overflow-y: auto;
  background: #1e1e1e;
  border-radius: 4px;
  padding: 10px;
  margin-top: 10px;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
}

.log-empty {
  color: #888;
  text-align: center;
  padding-top: 100px;
}

.log-entry {
  white-space: pre-wrap;
  word-break: break-all;
  padding: 2px 0;
}

.log-time {
  color: #888;
  margin-right: 8px;
}

.log-level-tag {
  display: inline-block;
  width: 32px;
  text-align: center;
  border-radius: 2px;
  margin-right: 6px;
  font-size: 11px;
  font-weight: bold;
}

.tag-d { color: #888; background: #333; }
.tag-i { color: #4fc3f7; background: #1a3a4a; }
.tag-w { color: #ffb74d; background: #4a3a1a; }
.tag-e { color: #ef5350; background: #4a1a1a; }

.log-type-tag {
  color: #aaa;
  background: #333;
  padding: 0 4px;
  border-radius: 2px;
  margin-right: 6px;
  font-size: 11px;
}

.log-tag {
  color: #81c784;
  margin-right: 6px;
}

.log-msg {
  color: #ddd;
}

.log-level-d { border-left: 3px solid #888; padding-left: 6px; }
.log-level-i { border-left: 3px solid #4fc3f7; padding-left: 6px; }
.log-level-w { border-left: 3px solid #ffb74d; padding-left: 6px; }
.log-level-e { border-left: 3px solid #ef5350; padding-left: 6px; }

.logDialog /deep/ .el-dialog__body {
  padding: 10px 20px;
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
